import { ReactNode } from 'react';

import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import { ButtonVariants } from 'constants/common';
import { Button } from 'shared-components/index';
import { cn } from 'utils/global';

interface Props {
  isOpen: boolean;
  children?: ReactNode;
  handleClearFields: VoidFunction;
  openFilter?: boolean;
}
const FilterFieldsContainer = ({ children, isOpen, handleClearFields, openFilter }: Props) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  const sharedFilterClassName = 'flex bg-white-00 dark:bg-black-900';
  const sharedFilterButtonsClassName = 'flex bg-white-00 dark:bg-black-900';

  if (!openFilter) {
    return (
      <>
        <div className="border border-neutral-200 dark:border-neutral-800 mb-8 rounded-md overflow-hidden">
          <div className={cn('py-4 ', sharedFilterClassName)}>{children}</div>
          <div className={cn('justify-end px-4 py-2', sharedFilterButtonsClassName)}>
            <Button
              type="button"
              variant={ButtonVariants.OUTLINE}
              onClick={handleClearFields}
              className="mr-2"
              leftIcon={faMagnifyingGlass}
            >
              {t('Clear')}
            </Button>
            <Button className="w-10 h-10" dataCy="bottom-submit-search-filter">
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </Button>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="rounded-md flex mb-4">
      <div className={(cn('pb-4'), sharedFilterClassName)}>{children}</div>
      <div
        className={cn(
          'bg-lightGray7 dark:bg-darkBlue items-center top-3 relative h-full self-center',
          sharedFilterButtonsClassName
        )}
      >
        <Button dataCy="bottom-submit-search-filter" className="mr-4">
          <FontAwesomeIcon icon={faMagnifyingGlass} />
        </Button>
        <Button type="button" variant={ButtonVariants.OUTLINE} onClick={handleClearFields}>
          {t('Clear')}
        </Button>
      </div>
    </div>
  );
};

export default FilterFieldsContainer;
